import React from "react"
import "./AdminName.css"
import { connect } from "react-redux"
import { UserProfileIcon, UserProfileDropdownIcon } from "../../common/Icons"

function AdminName({ onDropClick, dropDown, name }) {
  return (
    <div
      className="AdminName"
      onClick={() =>
        onDropClick(
          `${(dropDown === "on" && "off") || (dropDown === "off" && "on")}`
        )
      }
    >
      <span className="userProfileIcon">
        <UserProfileIcon />
      </span>
      <span className="businessName">{name}</span>
      <span className="dropDownIcon">
        <UserProfileDropdownIcon />
      </span>
    </div>
  )
}

export default connect(store => ({
  token: store.user.token,
  name: store.user.seller.name
}))(AdminName)
